<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import AppLayout from '@/components/layout/AppLayout.vue'
import AuthLayout from '@/components/layout/AuthLayout.vue'
import AdminLayout from '@/components/layout/AdminLayout.vue'
import { Loading03Icon } from '@/components/icons'

const route = useRoute()
const authStore = useAuthStore()

const layout = computed(() => {
  if (route.meta.layout === 'bare') return 'bare'
  if (route.meta.layout === 'auth') return 'auth'
  if (route.meta.layout === 'admin') return 'admin'
  return 'app'
})
</script>

<template>
  <Toast position="top-right" />
  <ConfirmDialog />

  <!-- Show loading screen while auth initializes -->
  <div v-if="authStore.loading" class="h-screen w-screen flex items-center justify-center bg-bg" role="status" aria-label="Loading PrintHQ">
    <Loading03Icon :size="24" class="animate-spin text-fg-3" />
  </div>

  <template v-else>
    <!-- Bare layout: no wrapper, component handles its own layout -->
    <RouterView v-if="layout === 'bare'" />

    <AuthLayout v-else-if="layout === 'auth'">
      <RouterView />
    </AuthLayout>

    <AdminLayout v-else-if="layout === 'admin'">
      <RouterView />
    </AdminLayout>

    <AppLayout v-else>
      <RouterView />
    </AppLayout>
  </template>
</template>
